<template>
    <div class="radio-group">
        <filter-block-radio
            v-for="option in options"
            :checked="checkedByAddressBar(option.slug, option.id)"
            @update:checked="check(option.id, option.name, option.slug, $event)"
            @reset:all="check(0, '', '', $event)"
            :fieldId="option.name"
            :label="option.name"
            :slug="option.slug"
            :key="option"
            :name="name"
        ></filter-block-radio>
    </div>
</template>
<script>

import FilterBlockRadio from "./FilterBlockRadio";
import {useStore} from 'vuex';

export default {
    emits: ["update:value", "reset:all"],
    props: {
        value: {
            type: Array,
            required: true,
        },
        name: String,
        options: {
            type: Array,
            required: true,
            validator: (value) => {
                const hasNameKey = value.every((option) =>
                    Object.keys(option).includes("name")
                );
                const hasIdKey = value.every((option) =>
                    Object.keys(option).includes("id")
                );
                return hasNameKey && hasIdKey;
            },
        },
    },
    setup(props, context) {
        const checkedByAddressBar = (optionSlug, optionId) => {
            // Check if optionId and optionsSlug already exists in store.state.Filters which contains the setted filters. If it exists we need to check the checkbox
            const store = useStore();
            let returnVal = false;
            if (store.state.Filters) {
                store.state.Filters.forEach((filterBlock) => {
                    if (Object.keys(filterBlock.values).length > 0) {
                        filterBlock.values.forEach((settedItem) => {
                            // console.log(settedItem.slug, optionSlug);
                            if (settedItem.slug === optionSlug && settedItem.id === optionId) {
                                returnVal = true;
                            }
                        });
                    }
                });
            }
            // console.log(optionSlug, returnVal)
            return returnVal;
        }
        const check = (optionId, optionName, optionSlug, checked) => {
            let updatedValue = [];

            let filterObject = {
                name: optionName,
                slug: optionSlug,
                id: optionId
            };

            // Remove if already selected
            updatedValue.forEach(function (arrValue, index) {
                if (arrValue.id === optionId) {
                    updatedValue.splice(index, 1);
                }
            })

            // Add checked checkbox
            if (checked) {
                updatedValue.push(filterObject);
            }

            // Reset all filters by emptying return array
            if (checked === false && optionId === 0 || optionId === 0) {
                updatedValue = [];
            }

            context.emit("update:value", updatedValue);
        };

        return {
            checkedByAddressBar,
            check
        };

    },
    components: {
        "filter-block-radio": FilterBlockRadio,
    }
};
</script>
